/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Exampreparationinformation_Courses2Inputs */

const de__field_exampreparationinformation_courses2 = /** @type {(inputs: _Field_Exampreparationinformation_Courses2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wöchentliches Prüfungstraining`)
};

/**

* @param {_Field_Exampreparationinformation_Courses2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_exampreparationinformation_courses2 = /** @type {((inputs?: _Field_Exampreparationinformation_Courses2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Exampreparationinformation_Courses2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_exampreparationinformation_courses2(inputs)
});
export { _field_exampreparationinformation_courses2 as "_field_examPreparationInformation_courses" }